export const  perexodChatMenu=(a)=>{
    return{
        type:"PEREXOD_CHAT_MENU",
        value:a
    }
}